import { useEffect, useState } from 'react'
import { LaunchDarkly, splitOrderRoles } from '@truepill/tpos-types'
import { useClient } from 'providers/LaunchDarklyProvider'
import { useTPCacheContext } from 'providers/TPCacheProvider'
import { usePlusClient } from 'providers/VisionRouter'
import type { Order } from 'types'
import { isOrderSplittable } from 'utils/splitOrder'

// Whether the current user can split this order: the customer's flag, a lead role and something to split
const useSplitOrderAccess = (order: Order): boolean => {
  const {
    tokenContext: { hasRole },
  } = usePlusClient()
  const { customersById } = useTPCacheContext()
  const { ldReady, ldIdentify } = useClient()
  const customerLegacyId = customersById[order.customerId]?.legacyId?.toString()

  // The flag is keyed on the customer, so take its value from the identify for this one
  const [flagOn, setFlagOn] = useState(false)
  useEffect(() => {
    if (!ldReady || !customerLegacyId) return
    setFlagOn(false)
    ldIdentify({ key: customerLegacyId }, undefined, (_error, flags) =>
      setFlagOn(!!flags?.[LaunchDarkly.FeatureFlags.ENABLE_ORDER_SPLITTING]),
    )
  }, [ldReady, ldIdentify, customerLegacyId])

  const hasAllowedRole = hasRole ? hasRole(splitOrderRoles) : false

  return flagOn && hasAllowedRole && isOrderSplittable(order)
}

export default useSplitOrderAccess
